/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ElectroSelectWithOther from '../../../../../../forms/components/inputs/ElectroSelectWithOther/ElectroSelectWithOther';
import ElectroMessageBarCont from '../../../../../../forms/components/inputs/ElectroMessageBarCont/ElectroMessageBarCont';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import styles from '../../../../ActionDrawer.module.scss';

import type Form from '../../../../../../forms/_.extend';

type TypeProps = {
  costCenter: Object,
  form: Form,
  actionDrawerStore: TypeActionDrawerStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class ArchiveCostCenterForm extends React.Component<*> {
  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { form }: TypeProps = this.props;
    const costCenter: Object = this.props.costCenter;

    const getChildData: Function = (child: string, val: string) => {
      return typeof costCenter[child] === 'undefined' ? null : costCenter[child][val];
    };

    const costCenterDetails: Array<Array> = [
      [
        t('general:trading_account'),
        `${getChildData('trading_account', 'name')} ${getChildData(
          'trading_account',
          'account_no'
        )}`,
      ],
      [t('general:cost_centers.labels.code'), costCenter.code],
      [t('general:cost_centers.labels.name'), costCenter.name],
    ];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:cost_centers.labels.details')}
          >
            <ActionDrawerTable data={costCenterDetails} />
            {costCenter.projects && costCenter.projects.length > 0 && (
              <ElectroMessageBarCont
                props={{
                  variant: 'warning',
                  message: t('general:cost_centers.messages.currently_in_use'),
                }}
              />
            )}
          </ActionDrawerBlock>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:cost_centers.reasons.why_archive')}
          >
            <ElectroSelectWithOther
              field={form.$('archiveCostCenterForm.reason')}
              otherHeading={`${t('general:reasons.provide_reason')} *`}
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.archive_cost_center')} />
      </React.Fragment>
    );
  }
}
